import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, formatApiError } from "../lib/auth";
import { toast, Toaster } from "sonner";

export default function RegisterPage() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [marketing, setMarketing] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true); setError("");
        try {
            await register(name.trim(), email.trim(), password, marketing);
            toast.success("Account aangemaakt!");
            navigate("/designer", { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div data-testid="register-page" className="min-h-[80vh] grid place-items-center px-6 py-12 bg-zinc-50">
            <Toaster />
            <div className="w-full max-w-md card p-8">
                <p className="label-tiny">Nieuw hier</p>
                <h1 className="font-display text-4xl mt-2">Maak een account.</h1>
                <p className="text-sm text-zinc-500 mt-2">Bewaar je ontwerpen en bestellingen.</p>
                <form onSubmit={onSubmit} className="mt-8 space-y-4">
                    <div>
                        <label className="label-tiny block mb-2">Naam</label>
                        <input data-testid="register-name-input" required value={name} onChange={(e) => setName(e.target.value)} className="input-flat" />
                    </div>
                    <div>
                        <label className="label-tiny block mb-2">E-mail</label>
                        <input data-testid="register-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-flat" />
                    </div>
                    <div>
                        <label className="label-tiny block mb-2">Wachtwoord (min 6 tekens)</label>
                        <input data-testid="register-password-input" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} className="input-flat" />
                    </div>
                    <label className="flex items-start gap-2.5 cursor-pointer pt-1">
                        <input data-testid="register-marketing-consent" type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="mt-0.5 w-4 h-4 accent-[var(--rose-deep)]" />
                        <span className="text-xs leading-relaxed" style={{ color: "var(--text-2)" }}>
                            <strong>Ja, ik wil graag</strong> nieuwsbrieven en aanbiedingen ontvangen van VdS Gift Shop (optioneel — je kan je altijd uitschrijven).
                        </span>
                    </label>
                    {error && <p data-testid="register-error" className="text-sm text-rose-600">{error}</p>}
                    <button data-testid="register-submit-button" type="submit" disabled={submitting} className="btn-primary w-full">
                        {submitting ? "Bezig..." : "Registreer"}
                    </button>
                </form>
                <p className="text-sm text-zinc-500 mt-6 text-center">
                    Heb je al een account? <Link data-testid="register-go-login" to="/login" className="underline">Login</Link>
                </p>
            </div>
        </div>
    );
}
